/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module MessageItemsModule
 */

import { IMetricsRealTimeUpdate, IPoolAnalyticsPolicy } from 'generated-types';
import { PoolAnalyticsPolicy } from 'object-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

type TPoolAnalyticsPolicy = Omit<IPoolAnalyticsPolicy, 'metrics_realtime_update'>;

/**
 * PoolAnalyticsPolicy config replacing message type properties with message item types.
 */
interface IPoolAnalyticsPolicyConfig extends TPoolAnalyticsPolicy {
    metrics_realtime_update: MessageItem<IMetricsRealTimeUpdate>;
}

/**
 * @description PoolAnalyticsPolicy ConfigItem.
 * @author alextsg
 */
export class PoolAnalyticsPolicyConfigItem extends MessageItem<IPoolAnalyticsPolicyConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: PoolAnalyticsPolicy,
            ...args,
        };

        super(extendedArgs);
    }

    /** @override */
    protected requiredFields(): string[] {
        return [
            'metrics_realtime_update',
        ];
    }
}
